import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useLinkedFindingFocus = (findingId: string | undefined) => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as { focusFinding?: boolean } | null;
  const focusLinked = state?.focusFinding;
  useEffect(() => {
    if (!focusLinked || !findingId) return;
    document.querySelector<HTMLElement>("[data-finding-heading]")?.focus();
    void navigate(`${location.pathname}${location.search}`, {
      replace: true,
      state: { focusFinding: false },
    });
  }, [focusLinked, findingId, navigate, location.pathname, location.search]);
};
